<template>
  <div class="content-wrapper">
    <div class="title"> {{ title }}</div>
    <div class="d-xl-flex mt-4">
      <div>
        <div class="contacts-placeholder">{{ placeholder1 }}:</div>
        <a :href="'tel:' + item1" class="contacts-detail-item"> {{ item1 }}</a>
      </div>
      <div class="ms-auto mt-4 mt-md-0">
        <div class="contacts-placeholder">{{ placeholder2 }}:</div>
        <div class="contacts-detail-item"> {{ item2 }}</div>
      </div>
    </div>
    <div class="mt-4">
      <div class="contacts-placeholder">{{ placeholder3 }}:</div>
      <div class="contacts-detail-item"> {{ item3 }}</div>
    </div>
    <div class="mt-4">
      <div class="contacts-placeholder">{{ placeholder4 }}:</div>
      <div class="contacts-detail-item"> {{ item4 }}</div>
      <div class="contacts-detail-item"> {{ item5 }}</div>
    </div>
    <slot></slot>
  </div>
</template>

<script>


export default {
  name: 'ContactsContent',
  components: {},
  props: {
    title: {
      type: String,
      required: true
    },
    placeholder1: {
      type: String,
      required: true
    },
    placeholder2: {
      type: String,
      required: true
    },
    placeholder3: {
      type: String,
      required: true
    },
    placeholder4: {
      type: String,
      required: true
    },
    item1: {
      type: String,
      required: true
    },
    item2: {
      type: String,
      required: true
    },
    item3: {
      type: String,
      required: true
    },
    item4: {
      type: String,
      required: true
    },
    item5: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.content-wrapper {
  color: $color-brown;
}

.contacts-detail-item {
  font-size: 18px;
}

.contacts-placeholder {
  font-size: $paragraph-2;
}

.title {
  font-size: $title-h5;
  font-family: $font-bold;
}

@media screen and (min-width: 768px) {
  .title {
    font-size: $title-h2;
  }
  .contacts-detail-item {
    font-size: 24px;
  }
}

</style>